import { EmployeeInfo } from "@/modules/types/employee/employee";
import { create } from "zustand";

interface employeeInfoStore {
  status: "idle" | "loading" | "success" | "error";
  employeeInfo?: EmployeeInfo;
  setStatus: (status: "idle" | "loading" | "success" | "error") => void;
  setEmployeeInfo: (employeeInfo: EmployeeInfo) => void;
  clearEmployeeInfo: () => void;
}

export const useEmployeeInfoStore = create<employeeInfoStore>((set) => ({
  status: "idle",
  employeeInfo: undefined,
  setStatus: (status) => set({ status }),
  setEmployeeInfo: (employeeInfo) => set({ employeeInfo }),
  clearEmployeeInfo: () => set({ employeeInfo: undefined }),
}));
